<template>
    <div class="emoji-picker">
        <span class="emoji-picker__title">{{ $t("Smileys") }}</span>
        <button
            v-for="emoji in smileyEmojis"
            :key="emoji"
            @click="insertEmoji(emoji)"
            class="emoji-btn"
        >
            {{ emoji }}
        </button>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                smileyEmojis: [
                '😄', '😃', '😀', '😁', '😆', '😅', '🤣', '😂',
                '🙂', '🙃', '🫠', '😉', '😊', '😇', '🥰', '😍',
                '🤩', '😘', '😗', '☺️', '😚', '😙', '🥲', '😋',
                '😛', '😜', '🤪', '😝', '🤑', '🤭', '🫢', '🫣',
                '🤫', '🤔', '🫡', '🤐', '🤨', '😐', '😑', '😶',
                '🫥', '😶‍🌫️', '🤥', '🫨', '🙄', '😯', '😪', '😴',
                '😌', '😔', '😢', '😕', '☹️', '🙁', '😣', '😖',
                '🤤', '😤', '😠', '😡', '🤬', '😷', '🤒', '🤕',
                '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '😵‍💫',
                '🤯', '🤠', '🥳', '🥸', '😎', '🤓', '🧐', '😟',
                '😥', '😰', '😨', '😱', '😭', '🤧', '🤒', '🤕',
                '🤢', '🤮', '🥶', '🥵', '🤯', '🤠', '🥳', '🥸',
                '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹️', '😣',
                '😖', '😫', '😩', '🥱', '😤', '😡', '🤬', '👿',
                '😈', '💀', '☠️', '💩', '🤡', '👹', '👺', '👻'
                ]
            };
        },
        props: {
            
        },
        methods: {
            insertEmoji(emoji) {
                this.$emit('add-emoji', emoji);
            }
        },
    };
  </script>

<style lang="scss" scoped>
// Design: 304px panel, "Smileys" caption, 8 columns of 34px cells
.emoji-picker {
  display: grid;
  grid-template-columns: repeat(8, 34px);
  gap: 2px;
  position: relative;
  z-index: 2;
  &__title {
    grid-column: 1 / -1;
    padding: 0 4px 4px;
    font-family: var(--wc-font-medium);
    font-size: 12px;
    line-height: 16px;
    color: var(--wc-text-3);
  }
}

.emoji-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: none;
  font-size: 20px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
}

.emoji-btn:hover {
  background: var(--wc-accent-soft);
}
</style>
